module.exports = __webpack_public_path__ + "images/loadingImage.png";


/*****************
 ** WEBPACK FOOTER
 ** ./DeliveryCreate/UI/app/content/images/loadingImage.png
 ** module id = 283
 ** module chunks = 0
 **/